if (!customElements.get('mini-cart')) {
  class MiniCart extends HTMLElement {
    constructor() {
      super();
      this.cartModalOpen = false;
      this.cartUrl = this.dataset.cartUrl;
      this.sectionId = this.dataset.sectionId;
      this.subToggles = this.querySelectorAll('.skio-radio-svg')
    }

    connectedCallback() {
      this.addDelegatedClickListeners();
      this.handleFormsWithinDrawer();
      
      document.addEventListener('DOMContentLoaded', () => {
        this.checkForGWPs();
      });
    }

    addDelegatedClickListeners() {
      window.addEventListener('click', (e) => {
        if (window.location.pathname === this.cartUrl) return;

        if(e.target.closest(`[href="${this.cartUrl}"]`)) {
            e.preventDefault();
            this.open();
            return;
        }
        if (e.target.closest('[data-close-cart]') && this.cartModalOpen) {
            this.close();
            return;
        }
        if (!e.target.closest('mini-cart') && !e.target.closest('[data-quickbuy-action]') && this.cartModalOpen) {
            this.close();
            return;
        }
        this.updateToggle();
      })

      window.addEventListener('submit', (e) => {
        const productForm = e.target.closest('[action="/cart/add"]');
        if(!productForm) return;
        
        const formData = new FormData(productForm);
        e.preventDefault();

        let discount = null;
        if (productForm.querySelector('[name="properties[Discount]"]') && productForm.querySelector('[name="properties[Discount]"]').value !== undefined) discount = productForm.querySelector('[name="properties[Discount]"]').value;

        const idToAdd = productForm.querySelector('select[name="id"]').value;
        const limit = productForm.querySelector('[name="limit"]')?.value;
        const late = productForm.querySelector('[name="late"]')?.value;
        const propertyInputs = productForm.querySelectorAll('[data-form-property]');
        const properties = {};

        if (propertyInputs) {
          for (let input of propertyInputs) {
            const key = input.getAttribute('name').match(/\[(.*?)\]/)[1];
            const val = input.value;

            properties[key] = val;
          }
        }

        this.addToCart(idToAdd, formData.get('selling_plan'), discount, properties, limit, late, formData.get('quantity')).then(res => {
          if (res.status === 200 || !res.status) {
            this.updateCartHtml(res).then(() => {
              if (window.location.pathname.includes('cart')) return;
              
              this.open()
            });
            return;
          } else this.stockAlert(res)
        });
      });

      this.addEventListener('click', (e) => {
        const qttyElement = e.target.closest('[data-cart-action="updateQty"]');
        const subsElement = e.target.closest('[data-cart-action="setSubs"]');
        const subOptions = e.target.closest('[data-cart-action="open-subs-options"]');

        

        if (qttyElement) {
          const {
            bundleItemIds = false,
            skioBundleItemIds = false,
            lineItemId,
            quantity = Number(quantity),
            limit,
            giftItem = false,
          } = qttyElement.dataset;

          if (quantity < 1 && giftItem) {
            sessionStorage.setItem(`removedGifts[${giftItem}]`, true);
          }

          const scrollTop = this.querySelector('form').scrollTop;
          this.classList.add('loading');
          this.updateQty(lineItemId, quantity, skioBundleItemIds, bundleItemIds, limit)
            .then((res) => {
              if (res) {
                this.updateCartHtml(res).then(() => {
                  this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
                });
              }
            }).finally(() => this.classList.remove('loading'));
        } else if (subOptions) {
          const subFrequency = subOptions.closest('[data-cart-action="setSubs"]')?.nextElementSibling;
          subFrequency.classList.toggle('!hidden');
          subOptions.textContent = subFrequency.classList.contains('!hidden') ? 'Edit' : 'Cancel';
        } else if (subsElement) {
          this.handleSubsElement(subsElement);
        }
      });
    }

    open() {
      this.click();
      this.querySelector('[data-close-cart]')?.focus();
      this.cartModalOpen = true;
      this.classList.replace('hidden', 'fixed');
      setTimeout(() => { this.classList.remove('translate-x-full') }, 10);
      document.body.classList.add('overlay');
      document.querySelectorAll(`[href="${this.cartUrl}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', 'true');
      });

      trapFocusInDialog(this);  
    }

    close() {
      this.cartModalOpen = false;
      this.classList.add('translate-x-full');
      document.body.classList.remove('overlay');
      document.querySelector('[data-close-cart]')?.focus();
      document.querySelector(`[href="${this.cartUrl}"]`)?.focus();
      document.querySelectorAll(`[href="${this.cartUrl}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
      });
      setTimeout(() => { this.classList.replace('fixed', 'hidden') }, 500);
    }

    checkForGWPs() {
      const additions = [];
      const removals = {};

      this.querySelectorAll('input[data-auto-gwp]').forEach((gwpEl) => {
        const gwpId = gwpEl.value;
        if (!gwpId) return;

        if (sessionStorage.getItem(`removedGifts[${gwpId}]`) && gwpEl.dataset.multiForm) {
          gwpEl.setAttribute('disabled', true);
          return;
        }

        const action = gwpEl.dataset.autoGwp;
        if (action === 'remove') {
          removals[gwpId] = 0;
          sessionStorage.removeItem(`addedGifts[${gwpId}]`);
          sessionStorage.setItem(`removedGifts[${gwpId}]`, true);
        } else {
          additions.push({
            id: gwpId,
            quantity: 1,
            properties: { _free_gift: true }
          });
          sessionStorage.setItem(`addedGifts[${gwpId}]`, true);
          sessionStorage.removeItem(`removedGifts[${gwpId}]`);
        }
      });

      if (additions.length === 0 && Object.keys(removals).length === 0) return;

      this.classList.add('loading');

      let promise = Promise.resolve();

      if (Object.keys(removals).length) {
        promise = promise.then(() => fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: removals, sections: [`${this.sectionId}`] })
        }).then((response) => response.json()));
      }

      if (additions.length) {
        promise = promise.then(() => fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify({ items: additions, sections: [`${this.sectionId}`] })
        }).then((response) => response.json()));
      }

      promise
        .then((cart) => {
          this.updateCartHtml(cart);
        })
        .catch((err) => {
          console.error('Bulk gift update failed:', err);
        })
        .finally(() => {
          this.classList.remove('loading');
        });
    }

    stockAlert(res) {
      if (res.status === 422) {
        const message = res.description.replace('All', 'You can only add').replace(' are in your cart', '');
        alert(message);
      } else alert(res.description)
    }

    handleFormsWithinDrawer() {
      // handle tiles within this drawer
      [...this.querySelectorAll('form[action="/cart/add"]')].forEach(form => {
        const atc = form.querySelector('button');
        form.setAttribute('action', '');
        form.addEventListener('submit', (e) => e.preventDefault());

        atc?.addEventListener('click', () => {
          const idToAdd = form.querySelector('select[name="id"]').value;
          this.classList.add('loading');
          const propertyInputs = form.querySelectorAll('[data-form-property]');
          const properties = {};

          if (propertyInputs) {
            for (let input of propertyInputs) {
              const key = input.getAttribute('name').match(/\[(.*?)\]/)[1];
              let val = input.value;
              
              if (key === '_free_gift' && val === 'true') {
                val = true;
              }

              properties[key] = val;
            }
          }
                    
          this.addToCart(idToAdd, false, false, properties)
            .then(res => {
              if (res.status === 200 || !res.status) {
                this.updateCartHtml(res);
                form.scrollIntoView();
                return;
              } else this.stockAlert(res)
            })
            .finally(() => this.classList.remove('loading'));
        })
      })
      this.querySelectorAll('[data-cart-action="changeSubs"]').forEach((el) => {
        el.addEventListener('click', (e) => this.changeSubsElement(e.target));
      });
      this.classList.remove('loading');
    }

    async quantityValidation(id, qty, method, limit) {
      const maxItemLimit = 24,
            variantLimit = limit;

      let quantity = qty,
          quantityToAdd = qty;

      const variantsInCart = await fetch('/cart.js').then(res => res.json()).then((cart) => {
        //Collect matched variants in cart
        const variants = cart.items.filter(item => item.variant_id == id);
        return variants;
      });

      if (variantsInCart.length) {
        const currentVariantQty = variantsInCart.map(variant => variant.quantity).reduce((v, q) => v + q);

        if (method == 'update') { 
          //If qty change, get qty difference
          quantityToAdd = qty - currentVariantQty;
        }
        else { 
          //Adding to cart, combine qty change w/ current item qty
          quantity += currentVariantQty;
        }
      }

      //Check for variant qty limits
      if (quantity > variantLimit) {
        const variantName = variantsInCart[0].title.split('/');
        variantName[0].split(' x ')?.shift();
        
        renderHelpModal({
          id: 'cart-issue',
          title: 'Cart Issue',
          copy: `Your cart can only contain a max of ${limit} units of ${variantName[0].split(' x ')?.shift()} / ${variantName[1]}`,
        });
        return false;
      }
      else {
        //Check for cart qty limits
        const cartTotalQty = parseInt(document.querySelector('[data-cart-count]').innerText);
        const availableToAdd = maxItemLimit - cartTotalQty;
        
        //Only limit if adding more qty
        if (availableToAdd < quantityToAdd && availableToAdd > 0) {
          renderHelpModal({
            id: 'cart-issue',
            title: 'Cart Issue',
            copy: `You can only add ${availableToAdd < 0 ? 0 : availableToAdd} additional items to your cart`,
          });
          return false;
        }
        else if (availableToAdd == 0 && quantityToAdd > 0) {
          renderHelpModal({
            id: 'cart-issue',
            title: 'Cart Issue',
            copy: `Your cart can only contain a max of ${maxItemLimit} items`,
          });
        }
        else {
          return true;
        }
      }
    }

    populateCart(html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      this.innerHTML = tempDiv.querySelector('mini-cart').innerHTML;
      const count = Number(tempDiv.querySelector('mini-cart').dataset.cartItemCount) || '';
      [...document.querySelectorAll('[data-cart-count]')].forEach(cartCount => {
        cartCount.innerHTML = count > 0 ? count : '';
      });
    }

    async fetchCart(responseOnly) {
      await fetch(window.location.pathname + `?section_id=${this.sectionId}`)
      .then(res => res.text())
      .then((text) => {
        if (responseOnly) {
          return 
        }
        else {
          this.populateCart(text);
          this.open();
        }
      });
    }

    async addToCart(id, selling_plan = null, discount = null, properties, limit, late, qty = 1) {
      const validated = await this.quantityValidation(id, 1, 'add', limit);

      if (!validated) {return false}
      
      const data = {
        id,
        'quantity': qty,
        sections: [`${this.sectionId}`]
      };

      if (properties && Object.keys(properties).length !== 0) {
        data['properties'] = properties;
        data['properties']['_bundle_id'] = false;
        if (discount) data['properties']['Discount'] = discount;
      }

      if (selling_plan) data['selling_plan'] = selling_plan;

      const cartContents = fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      })
        .then((response) => response.json())
        .catch(function(err) {
          console.error(err)
        });
      if (late == 'true') {
        renderHelpModal({
          id: 'shipping-notice',
          title: 'Shipping Notice',
          copy: document.querySelector('input[name=late]').dataset.messge
        });
      }
      return cartContents;
    }

    async updateCartHtml(res) {
      let newHtml = res?.sections?.[`${this.sectionId}`];

      if (!newHtml) {
        // alert('Something went wrong.');
        return;
      }

      this.populateCart(newHtml);
      this.checkForGWPs();
      this.handleFormsWithinDrawer();
      return;
    }

    async updateQty(id, qty, skioBundleItemIds, bundleItemIds, limit) {

      if (qty > 0) {
        const validated = await this.quantityValidation(id.split(':')[0], qty, 'update', limit);
        if (!validated) {return false}
      }

      const updates = {};
      if (bundleItemIds) {
        bundleItemIds.split(',').forEach(id => {
          updates[id] = 0;
        })
      } else if (skioBundleItemIds) {
        skioBundleItemIds.split(',').forEach(id => {
          updates[id] = 0;
        })
      } else {
        updates[id] = qty;
      }

      const data = {
        updates,
        sections: [`${this.sectionId}`],
      };

      const cartContents = fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
        });

      return cartContents;
    };

    changeSubsElement(subsElement) {
      const scrollTop = this.querySelector('form').scrollTop;
      const subsElementWrapper = subsElement.closest('[data-cart-action="changeSubs"]')
      const {
        lineItemId,
        quantity = Number(quantity)
      } = subsElementWrapper.dataset;
      const sellingPlan = subsElement.dataset.planValue;

      this.classList.add('loading');
      this.updateSubs(lineItemId, quantity, sellingPlan)
      .then((res) => {
        if (res) {
          this.updateCartHtml(res).then(() => {
            this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
          });
        }
      })
      .then(()=> this.updateToggle())
      .finally(() => this.classList.remove('loading'));
    }

    handleSubsElement(subsElement) {
      const scrollTop = this.querySelector('form').scrollTop;
      const sellingPlan = subsElement.dataset.sellingPlan;
      const {
        lineItemId,
        quantity = Number(quantity),
      } = subsElement.dataset;
      
      this.classList.add('loading');
      this.updateSubs(lineItemId, quantity, sellingPlan)
      .then((res) => {
        if (res) {
          this.updateCartHtml(res).then(() => {
            this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
          });
        }
      })
      .then(()=> this.updateToggle())
      .finally(() => this.classList.remove('loading'));
    }

    async updateSubs(id, qty, sellingPlan = null) {
      const data = {
        id: id,
        quantity: qty,
        selling_plan: sellingPlan,
        sections: [`${this.sectionId}`],
      };

      const cartContents = fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
        });
      return cartContents;
    };

    updateToggle(){
      this.subToggles = this.querySelectorAll('.skio-radio-svg');
      this.subToggles.forEach(function (el) {
        el.addEventListener('click', function () {
          el.classList.add('active');
        });
      });
    }
  }

  customElements.define('mini-cart', MiniCart);
}

if (!customElements.get('free-gift-dropdown')) {
  class FreeGiftDropdown extends HTMLElement {
      constructor() {
        super();
        this.chosenVariantId = null;
      }

      connectedCallback() {
        this.addEventListener('fake-select:changed', e => {
          this.chosenVariantId = e.target.value;
          const mainImage = this.querySelector('[data-main-image]');
          if (mainImage) {
            mainImage.src = e.target.querySelector('img')?.src.replace('250', '500');
            mainImage.srcset = ``;
          } 
        });
        
        this.addEventListener('click', e => {
          this.chosenVariantId = this.querySelector('fake-select')?.dataset.value;
          if (!e.target.closest('[data-add-gift]')) return;
          const cart = document.querySelector('mini-cart');
          if (!cart) return;
          
          cart.addToCart(this.chosenVariantId, false, false, { _free_gift: true })
            .then(res => {
              if (res.status === 200 || !res.status) {
                cart.updateCartHtml(res);
                cart.classList.remove('loading');
              }
            });
        })
      }


  }

  customElements.define('free-gift-dropdown', FreeGiftDropdown);
}